var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.70704 6.29292L6.99993 5.58582L5.58572 7.00003L6.29282 7.70714L10.5857 12L6.2928 16.2929L5.58569 17L6.99991 18.4143L7.70701 17.7071L11.9999 13.4142L16.2928 17.7071L16.9999 18.4142L18.4141 17L17.707 16.2929L13.4141 12L17.707 7.70715L18.4141 7.00004L16.9999 5.58583L16.2928 6.29293L11.9999 10.5858L7.70704 6.29292Z",
    fill: "#161B1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.e0cf55aa19ae02806b7890df24369986.svg";
export { ForwardRef as ReactComponent };